import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Signature on-load intro: big brand typography reveals, then wipes away to expose the site.
export const Intro = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    // Lock scroll while the intro plays
    document.body.style.overflow = "hidden";
    const timer = setTimeout(() => {
      setShow(false);
      document.body.style.overflow = "";
    }, 2200);
    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="intro"
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden"
          style={{ background: "#FFC800" }}
          data-testid="intro-overlay"
        >
          <div className="px-6 text-center">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.1, duration: 0.6 }}
              className="mb-6 flex items-center justify-center gap-4"
            >
              <span className="h-px w-10" style={{ backgroundColor: "#006eff" }} />
              <span className="text-[10px] md:text-xs uppercase tracking-[0.4em]" style={{ color: "#006eff" }}>
                Beverage Boutique Agency
              </span>
              <span className="h-px w-10" style={{ backgroundColor: "#006eff" }} />
            </motion.div>

            <div className="font-display font-semibold leading-[0.85] tracking-tight text-[15vw] md:text-[12vw] lg:text-[11rem]" aria-hidden="true">
              <span className="block overflow-hidden">
                <motion.span
                  className="block"
                  style={{ color: "#006eff" }}
                  initial={{ y: "110%" }}
                  animate={{ y: "0%" }}
                  transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
                >
                  MIXING
                </motion.span>
              </span>
              <span className="block overflow-hidden">
                <motion.span
                  className="block italic"
                  style={{ color: "#006eff" }}
                  initial={{ y: "110%" }}
                  animate={{ y: "0%" }}
                  transition={{ duration: 0.9, delay: 0.36, ease: [0.16, 1, 0.3, 1] }}
                >
                  DREAMS
                </motion.span>
              </span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
